import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-white py-4 mt-5">
      <Container>
        <Row>
          <Col md={4}>
            <h5>Jamaica Directory</h5>
            <p>Your comprehensive guide to Jamaica's best historic sites, restaurants, pet services, marinas, golf courses, and more.</p>
          </Col>
          <Col md={4}>
            <h5>Quick Links</h5>
            <ul className="list-unstyled">
              <li><Link to="/" className="text-white">Home</Link></li>
              <li><Link to="/category/historic-sites" className="text-white">Historic Sites</Link></li>
              <li><Link to="/category/restaurants" className="text-white">Restaurants</Link></li>
              <li><Link to="/category/pet-services" className="text-white">Pet Services</Link></li>
              <li><Link to="/category/marinas" className="text-white">Marinas</Link></li>
              <li><Link to="/category/golf-courses" className="text-white">Golf Courses</Link></li>
            </ul>
          </Col>
          <Col md={4}>
            <h5>Resources</h5>
            <ul className="list-unstyled">
              <li><Link to="/investor-resources" className="text-white">Investor Resources</Link></li>
              <li><Link to="/relocation-guide" className="text-white">Relocation Guide</Link></li>
              <li><a href="#" className="text-white">Contact Us</a></li>
              <li><a href="#" className="text-white">About</a></li>
              <li><a href="#" className="text-white">Privacy Policy</a></li>
            </ul>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="text-center">
            <p>&copy; {new Date().getFullYear()} Jamaica Directory. All rights reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
